import React from 'react';
import styled from 'styled-components';

import { HomeLayout } from '../../layouts';
import { BUY_CSPR_PATH, HOME_PATH } from '../../router/paths';
import { useCustomHistory } from '../../router/utils';
import { isCasperWalletMobileIOS } from '../../utils/user-agent';

import HomeMetrics from './HomeMetrics';
import { useWalletService } from '../../services';
import HomeSceneLayout from './components/HomeSceneLayout';
import { FlexColumn } from '@make-software/cspr-design';

const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    height: '100%',
    marginTop: [24, -128, -128, -132],
  })
);

export interface BlocksSceneProps {}

export const DashboardScene = (props: BlocksSceneProps) => {
  const history = useCustomHistory();
  const { buyCSPR, connect, isSignedIn } = useWalletService();

  if (history.location.pathname === BUY_CSPR_PATH) {
    if (config.with_buy_cspr_page && !isCasperWalletMobileIOS()) {
      if (!isSignedIn) {
        connect();
      } else {
        buyCSPR();
      }
    } else {
      history.replace(HOME_PATH);
    }
  }

  return (
    <HomeLayout title={`CSPR.live - Casper Network Explorer`}>
      <Container gap={24}>
        <HomeMetrics />
        <HomeSceneLayout />
      </Container>
    </HomeLayout>
  );
};

export default DashboardScene;
